import { render, staticRenderFns } from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=template&id=352708e4"
import script from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=style&index=0&id=352708e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports